import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Form,
  Card,
  Space,
  Select,
  Input,
  message,
  Image,
  DatePicker,
  Tag
} from 'antd';
import styles from '@/common/Layout/index.module.less';
import FormItem from '@/common/FormItem';
import 'react-quill/dist/quill.snow.css';
import CustomButton from '@/common/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBatches, updateQCapprove } from '../../redux/slice';
// import { PlusOutlined } from '@ant-design/icons';
import { history } from 'app/history';
import { useLocation } from 'react-router-dom';
import { EditOutlined } from '@ant-design/icons';
import truck from '../images/truck-delivery-done.gif';
import moment from 'moment';
import VerificationModal from '@/features/material/components/VerificationModal';
// Abandoning is done from the batch's test requests, not here:
// import DeactivateTrfModal from '../DeactivateTrfModal';
import { getLoggedInUser } from 'utilities/helpers';

const QCApprovalPage = ({ loading }) => {
  const { batchdetails } = useSelector((state) => state.qaapproval);
  console.log(batchdetails);
  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const { user } = getLoggedInUser();

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [batch, setBatch] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  /* Abandoning moved off this page entirely - it is done with Close on the
     batch's open test request. Kept for reference:
         const [showCloseModal, setShowCloseModal] = useState(false); */
  const [data, setData] = useState([
    {
      bacth_id: searchParams.get('id'),
      status: '',
      inhouse_retest_date: '',
      assay: '',
      load_water_content: '',
      is_assay: '',
      solvent_percent: ''
    }
  ]);
  const [samplings, setSamplings] = useState();
  const [truckShow, setTruckShow] = useState(false);
  useEffect(() => {
    handleGetAllBatchList();
  }, []);

  const handleGetAllBatchList = () => {
    let payload = { id: searchParams.get('id') };
    dispatch(getAllBatches(payload)).then((response) => {
      if (response?.payload?.success) {
        console.log(response?.payload?.data);
        // const batch_number = response?.payload?.data.filter(
        //   (items) => items?.id == searchParams.get('id')
        // );

        setBatch(response?.payload?.data?.inhouse_batch_number);
        const list = [...data];
        setSamplings(response?.payload?.data);
        form.setFieldsValue({ status: 'Approved' });
        setData([
          {
            bacth_id: searchParams.get('id'),
            status: response?.payload?.data?.status,
            inhouse_retest_date: response?.payload?.data?.inhouse_retest_date,
            assay: response?.payload?.data?.assay,
            load_water_content: response?.payload?.data?.lod_water_content,
            is_code_transfer: response?.payload?.data?.is_code_transfer,
            is_retest_batch: response?.payload?.data?.is_retest_batch,
            is_assay:
              response?.payload?.data?.material?.item == 'API'
                ? (list[0]['is_assay'] = true)
                : (list[0]['is_assay'] = false),
            solvent_percent: response?.payload?.data?.solvent_percent
          }
        ]);
      }
    });
  };
  console.log(batch);
  // const onSearch = (value) => {
  //   setSearch(value);
  // };
  console.log(data);

  const onChange = (index, param, e) => {
    console.log(index, e);
    const list = [...data];
    if (param == 'bacth_id') {
      const inhouse_batch = batchdetails.filter((batch) => batch.id == e);
      console.log(inhouse_batch[0]?.inhouse_batch_number?.substring(1, 5));
      inhouse_batch[0]?.inhouse_batch_number?.substring(0, 5) == 'BNAPI'
        ? (list[index]['is_assay'] = true)
        : (list[index]['is_assay'] = false);
    }

    list[index][param] = e;
    setData(list);
    setIsDirty(true);
  };
  console.log(data);
  // const handleClick = () => {
  //   setData([
  //     ...data,
  //     { bacth_id: '', status: '', assay: '', load_water_content: '' }
  //   ]);
  // };
  console.log(samplings);
  const onFinish = () => {
    /* `status` is seeded from the batch's CURRENT status, so a form nobody has
       touched still carries Quarantine. Quarantine is no longer an option in the
       dropdown, so reaching here means no decision was picked - refuse rather
       than send Quarantine to bacth_qc, which would write it back as the batch
       status and close nothing.

       Checked before the sampling guard below: this is about picking a decision,
       and it applies whether or not anything has been sampled.

       Previously this opened the close modal in place of a decision:
           if (data?.[0]?.status === 'Quarantine') {
             setShowCloseModal(true);
             return;
           }
       Abandoning now lives solely on the batch's open test request (Close). */
    if (data?.[0]?.status === 'Quarantine') {
      message.error(
        'Select a decision — Approved, Rejected or Partially ID Approved. To abandon this cycle, use Close on the batch’s test request.'
      );
      return;
    }

    /* Batches of a material flagged sampling_required = false are received and
       dispositioned without ever being sampled, so the "nothing has been
       sampled" gate would block an approval that is entirely correct. The flag
       is a snapshot taken on the batch at receipt, not the material's live
       value, so editing the master cannot retroactively unblock an old batch. */
    const samplingRequired = samplings?.sampling_required !== false;
    const hasSampledContainer = samplings?.containers?.some(
      (c) => c.is_active === true && c.sampling_status === 'Sampled'
    );
    /* Superseded, kept for reference - it blocked every batch with nothing
       sampled, including ones whose material is never sampled at all:
           if (!hasSampledContainer) { */
    if (samplingRequired && !hasSampledContainer) {
      message.error(
        'Approval not allowed. No containers have been sampled for this batch.'
      );
      return;
    }
    setSubmitting(true);
    setTruckShow(true);
    const payload = {
      batch_list: data
    };
    dispatch(updateQCapprove(payload)).then(function (response) {
      if (response?.payload?.success) {
        setData([
          { bacth_id: '', status: '', assay: '', load_water_content: '' }
        ]);
        form.resetFields();
        setTruckShow(false);
        setSubmitting(false);
        message.success(response?.payload?.message);
        history.push('/batches-list?type=batches');
      } else {
        setTruckShow(false);
        setSubmitting(false);
      }
    });
  };

  const handleQA = () => {
    setIsModal(true);
  };

  // Identification Test batches can only be rejected or partially ID approved
  /* Quarantine removed from the decision list. It was never a result - it sends
     the cycle back with nothing recorded, which is an abandon. Abandoning is done
     with Close on the batch's open test request, where it collects a reason, a QC
     Level 3 re-authentication and a stock disposition.
     Was: ['Quarantine', 'Approved', 'Rejected', 'Partially ID Approved'] */
  const statusOptions =
    samplings?.test_to_be_performed === 'Identification Test'
      ? ['Rejected', 'Partially ID Approved']
      : ['Approved', 'Rejected', 'Partially ID Approved'];
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      // onFinishFailed={onFinishFailed}
    >
      <Card
        title="QC APPROVAL"
        className={styles.CustomPanel}
        extra={
          user?.level == 3 ? (
            <CustomButton onClick={() => setIsEdit(true)}>
              <EditOutlined />
            </CustomButton>
          ) : null
        }
      >
        {data?.length
          ? data?.map((item, index) => {
              return (
                <>
                  <Card className={styles.CustomPanel12} key={index}>
                    <Row gutter={24} key={index}>
                      <Col xs={24} xl={8} span={12} md={24} sm={24}>
                        <FormItem
                          label="Inhouse Batch Number"
                          rules={[
                            {
                              required: false,
                              message: 'Select In house batch number'
                            }
                          ]}
                          className={styles.customLable}
                        >
                          <Input value={batch} disabled />
                          {/* <Select
                            showSearch
                            placeholder="Select In house batch number"
                            optionFilterProp="children"
                            onChange={(e) => onChange(index, 'bacth_id', e)}
                            onSearch={onSearch}
                          >
                            {batchdetails?.map((item, index) => {
                              return (
                                <option value={item.id} key={index}>
                                  {item.inhouse_batch_number}
                                </option>
                              );
                            })}
                          </Select> */}
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={8} span={12} md={24} sm={24}>
                        <FormItem
                          label="Status"
                          rules={[
                            {
                              required: false,
                              message: 'Enter name of the material'
                            }
                          ]}
                          className={styles.customLable}
                        >
                          {samplings?.status && !isEdit ? (
                            <Input
                              placeholder="Enter assay"
                              disabled
                              value={samplings?.status || ''}
                            />
                          ) : (
                            <Select
                              showSearch
                              placeholder="Select status"
                              defaultValue={
                                statusOptions.includes(samplings?.status)
                                  ? samplings?.status
                                  : undefined
                              }
                              // optionFilterProp="children"
                              onChange={(e) => onChange(index, 'status', e)}
                            >
                              {statusOptions.map((status) => (
                                <option value={status} key={status}>
                                  {status}
                                </option>
                              ))}
                            </Select>
                          )}
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={4} span={12} md={24} sm={24}>
                        <FormItem
                          label="Retest Date"
                          // name="inhouse_retest_date"
                          rules={[
                            {
                              required: false,
                              message: 'Select Retest Date'
                            }
                          ]}
                          className={styles.customLable}
                        >
                          {!isEdit ? (
                            <Input
                              placeholder="Enter retest date"
                              disabled
                              value={
                                samplings?.inhouse_retest_date
                                  ? moment(
                                      samplings?.inhouse_retest_date
                                    ).format('DD-MM-YYYY')
                                  : ''
                              }
                            />
                          ) : (
                            <DatePicker
                              style={{ width: '100%' }}
                              onChange={(e) =>
                                onChange(index, 'inhouse_retest_date', e)
                              }
                            />
                          )}
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={4} span={12} md={24} sm={24}>
                        <FormItem
                          label="Expiry Date"
                          rules={[
                            {
                              required: false,
                              message: 'Select Expiry Date'
                            }
                          ]}
                          className={styles.customLable}
                        >
                          {!isEdit ? (
                            <Input
                              placeholder="Enter Expiry date"
                              disabled
                              value={
                                samplings?.qc_expiry_date
                                  ? moment(samplings?.qc_expiry_date).format(
                                      'DD-MM-YYYY'
                                    )
                                  : ''
                              }
                            />
                          ) : (
                            <DatePicker
                              style={{ width: '100%' }}
                              onChange={(e) =>
                                onChange(index, 'qc_expiry_date', e)
                              }
                            />
                          )}
                        </FormItem>
                      </Col>

                      {/* AR Number is assigned by QC and entered here, at the
                          decision - not when the warehouse raises the test
                          request, where it does not exist yet. Optional: a batch
                          can be decided without one and the number filled in on a
                          later decision. Leaving it blank never clears an AR that
                          is already recorded, because the backend only writes a
                          non-empty value. */}
                      <Col xs={24} xl={4} span={12} md={24} sm={24}>
                        <FormItem
                          label="AR Number"
                          rules={[
                            {
                              required: false,
                              message: 'Enter AR Number'
                            }
                          ]}
                          className={styles.customLable}
                        >
                          {!isEdit ? (
                            <Input
                              placeholder="Not yet assigned"
                              disabled
                              value={samplings?.ar_number || ''}
                            />
                          ) : (
                            <Input
                              placeholder="Enter AR Number (optional)"
                              defaultValue={samplings?.ar_number || ''}
                              onChange={(e) =>
                                onChange(index, 'ar_no', e.target.value)
                              }
                            />
                          )}
                        </FormItem>
                      </Col>

                      {/* {index == 0 ? (
                        <Col xs={6} xl={2} span={12} md={24} sm={24}>
                          <CustomButton 
                            loading={loading}
                            onClick={handleClick}
                            style={{ marginTop: '23px' }}
                          >
                            <PlusOutlined />
                          </CustomButton >
                        </Col>
                      ) : (
                        ''
                      )} */}
                      {item?.is_assay ? (
                        <>
                          {samplings?.assay && !isEdit ? (
                            <Col xs={20} xl={8} span={12} md={24} sm={24}>
                              <FormItem
                                label="Assay(%)"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Enter name of the material'
                                  }
                                ]}
                                className={styles.customLable}
                                onChange={(e) =>
                                  onChange(index, 'assay', e.target.value)
                                }
                              >
                                <Input
                                  placeholder="Enter assay"
                                  disabled
                                  value={data?.[0]?.assay || ''}
                                />
                              </FormItem>
                            </Col>
                          ) : (
                            <Col xs={20} xl={8} span={12} md={24} sm={24}>
                              <FormItem
                                label="Assay (%)"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Enter name of the material'
                                  }
                                ]}
                                className={styles.customLable}
                                onChange={(e) =>
                                  onChange(index, 'assay', e.target.value)
                                }
                              >
                                <Input
                                  placeholder="Enter assay"
                                  value={data?.[0]?.assay || ''}
                                />
                              </FormItem>
                            </Col>
                          )}

                          {/* <Col
                            xs={4}
                            xl={2}
                            span={12}
                            md={24}
                            sm={24}
                            className={styles.qr}
                          >
                            <Input
                              disabled
                              value={'%'}
                              style={{ textAlign: 'center' }}
                            />
                          </Col> */}
                          {samplings?.lod_water_content && !isEdit ? (
                            <Col xs={20} xl={8} span={12} md={24} sm={24}>
                              <FormItem
                                label="LOD or Water Content (%)"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Enter LOD or Water Content'
                                  }
                                ]}
                                className={styles.customLable}
                                onChange={(e) =>
                                  onChange(
                                    index,
                                    'load_water_content',
                                    e.target.value
                                  )
                                }
                              >
                                <Input
                                  placeholder="Enter LOD or Water content"
                                  value={data?.[0]?.load_water_content || ''}
                                  disabled
                                />
                              </FormItem>
                            </Col>
                          ) : (
                            <Col xs={20} xl={8} span={12} md={24} sm={24}>
                              <FormItem
                                label="LOD or Water Content (%)"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Enter LOD or Water Content'
                                  }
                                ]}
                                className={styles.customLable}
                                onChange={(e) =>
                                  onChange(
                                    index,
                                    'load_water_content',
                                    e.target.value
                                  )
                                }
                              >
                                <Input
                                  placeholder="Enter LOD or Water content"
                                  value={data?.[0]?.load_water_content || ''}
                                />
                              </FormItem>
                            </Col>
                          )}
                          {/* <Col
                            xs={4}
                            xl={2}
                            span={12}
                            md={24}
                            sm={24}
                            className={styles.qr}
                          >
                            <Input
                              disabled
                              value={'%'}
                              style={{ textAlign: 'center' }}
                            />
                          </Col> */}
                          {samplings?.lod_water_content && !isEdit ? (
                            <Col xs={20} xl={8} span={12} md={24} sm={24}>
                              <FormItem
                                label="Solvent (%)"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Enter Solvent'
                                  }
                                ]}
                                className={styles.customLable}
                                onChange={(e) =>
                                  onChange(
                                    index,
                                    'solvent_percent',
                                    e.target.value
                                  )
                                }
                              >
                                <Input
                                  placeholder="Enter Solvent"
                                  value={data?.[0]?.solvent_percent || ''}
                                  disabled
                                />
                              </FormItem>
                            </Col>
                          ) : (
                            <Col xs={20} xl={8} span={12} md={24} sm={24}>
                              <FormItem
                                label="Solvent (%)"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Enter Solvent'
                                  }
                                ]}
                                className={styles.customLable}
                                onChange={(e) =>
                                  onChange(
                                    index,
                                    'solvent_percent',
                                    e.target.value
                                  )
                                }
                              >
                                <Input
                                  placeholder="Enter Solvent"
                                  value={data?.[0]?.solvent_percent || ''}
                                />
                              </FormItem>
                            </Col>
                          )}
                          {/* <Col
                            xs={4}
                            xl={2}
                            span={12}
                            md={24}
                            sm={24}
                            className={styles.qr}
                          >
                            <Input
                              disabled
                              value={'%'}
                              style={{ textAlign: 'center' }}
                            />
                          </Col> */}
                        </>
                      ) : (
                        ''
                      )}
                    </Row>
                    {/* A property of the batch, snapshotted from the material at
                        receipt - read-only here. Shown as its own line because it
                        explains WHY the sampling gate is or is not in force, which
                        matters before approving, not while filling the fields.
                        Amber for the exception: a batch that will never be sampled
                        is the one worth noticing. */}
                    <div style={{ marginTop: '4px' }}>
                      <Tag
                        color={
                          samplings?.sampling_required === false
                            ? '#FF9800'
                            : '#17a2b8'
                        }
                        style={{
                          borderRadius: '12px',
                          padding: '2px 14px',
                          fontWeight: 600
                        }}
                      >
                        {samplings?.sampling_required === false
                          ? 'Sampling Not Required'
                          : 'Sampling Required'}
                      </Tag>
                    </div>
                  </Card>
                  <br />
                </>
              );
            })
          : ''}
      </Card>
      <br />
      <FormItem className="text-center">
        <Space>
          <CustomButton
            type="primary"
            onClick={() => history.back()}
            loading={loading}
            ghost
          >
            Cancel
          </CustomButton>
          {truckShow ? (
            <Image
              src={truck}
              preview={false}
              style={{ width: '100px !important', height: '100px' }}
            />
          ) : // samplings?.inhouse_retest_date || samplings?.expiry_date ? (
          samplings?.is_retest_batch || samplings?.is_code_transfer ? (
            <CustomButton
              type="primary"
              onClick={() => handleQA()}
              loading={loading}
              disabled={user?.level != 3 || !isDirty}
            >
              Initiate Verification
            </CustomButton>
          ) : (
            // )
            <CustomButton
              type="primary"
              htmlType="submit"
              loading={submitting}
              disabled={submitting || user?.level != 3 || !isDirty}
            >
              Approve
            </CustomButton>
          )}
        </Space>
      </FormItem>
      {/* The close flow no longer lives on this page - Quarantine is not a
          decision, and Close on the batch's test request is the one place a cycle
          is abandoned. Kept for reference:
      <DeactivateTrfModal
        visible={showCloseModal}
        batchDetailsId={searchParams.get('id')}
        onCancel={() => setShowCloseModal(false)}
        onChanged={() => {
          setShowCloseModal(false);
          history.push('/batches-list?type=batches');
        }}
      /> */}
      {isModal ? (
        <VerificationModal
          isModal={isModal}
          materials={data}
          setIsModal={setIsModal}
          setIsEdit={setIsEdit}
          page="BatchApproval"
        />
      ) : (
        ''
      )}
    </Form>
  );
};
export default QCApprovalPage;
